import React, { Component, ReactNode } from 'react';
import { Typography } from '@ag1/ui';
import styles from './PreviewErrorBoundary.module.scss';

interface Props {
  preview?: boolean;
  section: string;
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class PreviewErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidUpdate(previousProps: Props, previousState: State) {
    // eslint-disable-next-line react/destructuring-assignment
    if (previousState.hasError && previousProps.children !== this.props.children) {
      this.setState({ hasError: false });
    }
  }

  public render() {
    const { preview, section, children } = this.props;

    // eslint-disable-next-line react/destructuring-assignment
    if (this.state.hasError && !!preview) {
      return (
        <div className={styles.root}>
          <Typography variant="body" size="2">
            An error occurred while displaying data in
            <strong>{` ${section}`}</strong>
            <br />
            Please fill in correctly all required fields in this section
          </Typography>
          <Typography variant="body" size="3">
            If all the necessary data is filled in - section will be reloaded
          </Typography>
        </div>
      );
    }

    return children;
  }
}

export default PreviewErrorBoundary;
